module.exports = __webpack_public_path__ + "img/ch16_01_菜市场讲价.6e8f92cf.jpg";